import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Citations from './views/Citations.vue'
import About from './views/About.vue'
import PulsarTimingForDummies from './views/PulsarTimingForDummies.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: (route) => ({ doo: route.query.do }) //?do=x passes { do: 'x' } to home component
    },
    {
      path: '/game',
      name: 'game',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "game" */ './views/Game.vue'),
      props: true
    },
    {
      path: '/pulsarmaps',
      name: 'pulsarmaps',
      component: () => import(/* webpackChunkName: "pulsarmaps" */ './views/PulsarMaps.vue')
    },
    {
      path: '/citations',
      name: 'citations',
      component: Citations
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/pulsartiming',
      name: 'pulsartiming',
      component: PulsarTimingForDummies
    },
    {
      path: '/derivation',
      name: 'derivation',
      component: () => import(/* webpackChunkName: "derivation" */ './views/Derivation.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
